module.exports = __webpack_public_path__ + "static/img/bo.4128202a.svg";